/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PlatformApiResultOfDataSourceResultDtoOfDeviceDto } from '../models/platform-api-result-of-data-source-result-dto-of-device-dto';
import { PlatformApiResultOfDeviceDto } from '../models/platform-api-result-of-device-dto';
import { PlatformApiResultOfDeviceFullDto } from '../models/platform-api-result-of-device-full-dto';
import { PlatformApiResultOfPresentUserListDto } from '../models/platform-api-result-of-present-user-list-dto';
import { deleteDevices } from '../fn/device/delete-devices';
import { DeleteDevices$Params } from '../fn/device/delete-devices';
import { getDevicesId } from '../fn/device/get-devices-id';
import { GetDevicesId$Params } from '../fn/device/get-devices-id';
import { getDevicesQueryPcnamePcname } from '../fn/device/get-devices-query-pcname-pcname';
import { GetDevicesQueryPcnamePcname$Params } from '../fn/device/get-devices-query-pcname-pcname';
import { getDevicesQueryPresentuserlistPcname } from '../fn/device/get-devices-query-presentuserlist-pcname';
import { GetDevicesQueryPresentuserlistPcname$Params } from '../fn/device/get-devices-query-presentuserlist-pcname';
import { postDevices } from '../fn/device/post-devices';
import { PostDevices$Params } from '../fn/device/post-devices';
import { postDevicesQueryDatasource } from '../fn/device/post-devices-query-datasource';
import { PostDevicesQueryDatasource$Params } from '../fn/device/post-devices-query-datasource';
import { putDevices } from '../fn/device/put-devices';
import { PutDevices$Params } from '../fn/device/put-devices';

@Injectable({ providedIn: 'root' })
export class PlatformDeviceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getDevicesQueryPcnamePcname()` */
  static readonly GetDevicesQueryPcnamePcnamePath = '/api/devices/query/pcname/{pcName}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDevicesQueryPcnamePcname()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDevicesQueryPcnamePcname$Response(params: GetDevicesQueryPcnamePcname$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfDeviceFullDto>> {
    return getDevicesQueryPcnamePcname(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDevicesQueryPcnamePcname$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDevicesQueryPcnamePcname(params: GetDevicesQueryPcnamePcname$Params, context?: HttpContext): Observable<PlatformApiResultOfDeviceFullDto> {
    return this.getDevicesQueryPcnamePcname$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfDeviceFullDto>): PlatformApiResultOfDeviceFullDto => r.body)
    );
  }

  /** Path part for operation `getDevicesQueryPresentuserlistPcname()` */
  static readonly GetDevicesQueryPresentuserlistPcnamePath = '/api/devices/query/presentuserlist/{pcName}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDevicesQueryPresentuserlistPcname()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDevicesQueryPresentuserlistPcname$Response(params: GetDevicesQueryPresentuserlistPcname$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfPresentUserListDto>> {
    return getDevicesQueryPresentuserlistPcname(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDevicesQueryPresentuserlistPcname$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDevicesQueryPresentuserlistPcname(params: GetDevicesQueryPresentuserlistPcname$Params, context?: HttpContext): Observable<PlatformApiResultOfPresentUserListDto> {
    return this.getDevicesQueryPresentuserlistPcname$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfPresentUserListDto>): PlatformApiResultOfPresentUserListDto => r.body)
    );
  }

  /** Path part for operation `postDevicesQueryDatasource()` */
  static readonly PostDevicesQueryDatasourcePath = '/api/devices/query/datasource';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postDevicesQueryDatasource()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postDevicesQueryDatasource$Response(params: PostDevicesQueryDatasource$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfDeviceDto>> {
    return postDevicesQueryDatasource(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postDevicesQueryDatasource$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postDevicesQueryDatasource(params: PostDevicesQueryDatasource$Params, context?: HttpContext): Observable<PlatformApiResultOfDataSourceResultDtoOfDeviceDto> {
    return this.postDevicesQueryDatasource$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfDeviceDto>): PlatformApiResultOfDataSourceResultDtoOfDeviceDto => r.body)
    );
  }

  /** Path part for operation `getDevicesId()` */
  static readonly GetDevicesIdPath = '/api/devices/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDevicesId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDevicesId$Response(params: GetDevicesId$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfDeviceDto>> {
    return getDevicesId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDevicesId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDevicesId(params: GetDevicesId$Params, context?: HttpContext): Observable<PlatformApiResultOfDeviceDto> {
    return this.getDevicesId$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfDeviceDto>): PlatformApiResultOfDeviceDto => r.body)
    );
  }

  /** Path part for operation `putDevices()` */
  static readonly PutDevicesPath = '/api/devices';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putDevices()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putDevices$Response(params: PutDevices$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfDeviceDto>> {
    return putDevices(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putDevices$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putDevices(params: PutDevices$Params, context?: HttpContext): Observable<PlatformApiResultOfDeviceDto> {
    return this.putDevices$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfDeviceDto>): PlatformApiResultOfDeviceDto => r.body)
    );
  }

  /** Path part for operation `postDevices()` */
  static readonly PostDevicesPath = '/api/devices';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postDevices()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postDevices$Response(params: PostDevices$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfDeviceDto>> {
    return postDevices(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postDevices$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postDevices(params: PostDevices$Params, context?: HttpContext): Observable<PlatformApiResultOfDeviceDto> {
    return this.postDevices$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfDeviceDto>): PlatformApiResultOfDeviceDto => r.body)
    );
  }

  /** Path part for operation `deleteDevices()` */
  static readonly DeleteDevicesPath = '/api/devices';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteDevices()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteDevices$Response(params: DeleteDevices$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfDeviceDto>> {
    return deleteDevices(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteDevices$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteDevices(params: DeleteDevices$Params, context?: HttpContext): Observable<PlatformApiResultOfDeviceDto> {
    return this.deleteDevices$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfDeviceDto>): PlatformApiResultOfDeviceDto => r.body)
    );
  }

}
